module.exports = __webpack_public_path__ + "static/media/adventurer-silver-yeti.3592d383.png";